
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/unit.js';
            vueApps['app/unit.js'] = App0;
        

            import App1 from './app/dummy.js';
            vueApps['app/dummy.js'] = App1;
        

            import App2 from './app/search.js';
            vueApps['app/search.js'] = App2;
        

            import App3 from './app/navbar.js';
            vueApps['app/navbar.js'] = App3;
        

            import App4 from './app/UnitsOfTheDay.js';
            vueApps['app/UnitsOfTheDay.js'] = App4;
        

            import App5 from './app/SimilarUnits.js';
            vueApps['app/SimilarUnits.js'] = App5;
        

            import App6 from './app/LastViewedUnits.js';
            vueApps['app/LastViewedUnits.js'] = App6;
        

            import App7 from './app/landingpagehouse.js';
            vueApps['app/landingpagehouse.js'] = App7;
        

            import App8 from './app/landingPageMap.js';
            vueApps['app/landingPageMap.js'] = App8;
        

            import App9 from './app/landingpageoffers.js';
            vueApps['app/landingpageoffers.js'] = App9;
        

            import App10 from './app/landingpageflat.js';
            vueApps['app/landingpageflat.js'] = App10;
        

            import App11 from './app/li-und-umgebung.js';
            vueApps['app/li-und-umgebung.js'] = App11;
        

            import App12 from './app/insel-lindau.js';
            vueApps['app/insel-lindau.js'] = App12;
        

            import App13 from './app/nonnenhorn.js';
            vueApps['app/nonnenhorn.js'] = App13;
        

            import App14 from './app/wasserburg.js';
            vueApps['app/wasserburg.js'] = App14;
        

            import App15 from './app/landingpagepetallowed.js';
            vueApps['app/landingpagepetallowed.js'] = App15;
        

            import App16 from './app/urlaub-mit-bergblick.js';
            vueApps['app/urlaub-mit-bergblick.js'] = App16;
        

            import App17 from './app/seenahes-umland.js';
            vueApps['app/seenahes-umland.js'] = App17;
        

            import App18 from './app/urlaub-mit-seeblick.js';
            vueApps['app/urlaub-mit-seeblick.js'] = App18;
        

            import App19 from './app/familienurlaub.js';
            vueApps['app/familienurlaub.js'] = App19;
        

            import App20 from './app/langenargen.js';
            vueApps['app/langenargen.js'] = App20;
        

            import App21 from './app/kressbronn.js';
            vueApps['app/kressbronn.js'] = App21;
        

        
                import Comp22 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp22);
            

                import Comp23 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp23);
            

                import Comp24 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp24);
            

                import Comp25 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp25);
            

                import Comp26 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp26);
            

                import Comp27 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp27);
            

                import Comp28 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp28);
            

                import Comp29 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp29);
            

                import Comp30 from './childrenage.vue';
                Vue.component('childrenage',Comp30);
            

                import Comp31 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp31);
            

                import Comp32 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp32);
            

                import Comp33 from './comp/DateRangeExt.vue';
                Vue.component('voffice-daterange-ext',Comp33);
            

                import Comp34 from './comp/SearchFilterTokens.vue';
                Vue.component('search-filter-tokens',Comp34);
            

                import Comp35 from './comp/PopupDialog.vue';
                Vue.component('voffice-popup-dlg',Comp35);
            

                import Comp36 from './comp/Accordion.vue';
                Vue.component('voffice-accordion',Comp36);
            

                import Comp37 from './comp/pricelist.vue';
                Vue.component('price-tab',Comp37);
            

                import Comp38 from './costHelpThirtyTage.vue';
                Vue.component('cost-help-thirtytage',Comp38);
            

                import Comp39 from './costHelpSixtyTage.vue';
                Vue.component('cost-help-sixtytage',Comp39);
            

                import Comp40 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp40);
            

                import Comp41 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp41);
            

                import Comp42 from './comp/gmap.js';
                Vue.component('voffice-gmap',Comp42);
            

                import Comp43 from './comp/SearchFilterTokens-v2.vue';
                Vue.component('search-filter-tokens-v2',Comp43);
            

                import Comp44 from './imageCarousel.vue';
                Vue.component('img-carousel',Comp44);
            

                import Comp45 from './offershelp.vue';
                Vue.component('offer-help',Comp45);
            

                import Comp46 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp46);
            

                import Comp47 from './comp/IncreaseNumber.vue';
                Vue.component('increase-number',Comp47);
            

                import Comp48 from './pricehelp.vue';
                Vue.component('price-help',Comp48);
            

                import Comp49 from './teamMember.vue';
                Vue.component('voffice-team-member',Comp49);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    